import { useState } from "react";
import { MealDisplayFront } from "../MealDisplayTile/MealDisplayFront";
import { MealDisplayBack } from "../MealDisplayTile/MealDisplayBack";

export function UserMealGrid({ mealToDisplay, handleRemoveMeal, handleEdit }) {
  const [isFlipped, setIsFlipped] = useState(false);

  const toggleFlip = (newState) => {
    setIsFlipped(newState);
  };
  return (
    <div className="flex-1 overflow-auto p-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {mealToDisplay.map((recipe) => {
          return (
            <div
              key={recipe.mealId}
              className="relative h-[380px]"
              style={{ perspective: "1000px" }}
            >
              <div
                onClick={() => setIsFlipped(!isFlipped)}
                className="relative w-full h-full cursor-pointer transition-transform duration-500"
                style={{
                  transformStyle: "preserve-3d",
                  transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)",
                }}
              >
                {/* Front of Card */}
                <MealDisplayFront recipe={recipe} />

                {/* Back of Card */}
                <MealDisplayBack
                  recipe={recipe}
                  toggleFlip={toggleFlip}
                  deleteMeal={handleRemoveMeal}
                  editMeal={handleEdit}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
